/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.transcripts.rpc.AcademyTranscriptsRpc
 */
import * as References from './AcademyTranscriptsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.transcripts.rpc.AcademyTranscriptsRpc#checkCaptionsExist
 */
export const CHECK_CAPTIONS_EXIST_QUERY_FIELD_NAME = 'com_hubspot_academy_transcripts_rpc_AcademyTranscriptsRpc_checkCaptionsExist';
export const CHECK_CAPTIONS_EXIST_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_CAPTIONS_EXIST_QUERY_FIELD_NAME,
  args: ['contentIds'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.checkCaptionsExistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});